// extracted by mini-css-extract-plugin
export var description = "styles-module--description--wk6nk";
export var input = "styles-module--input--B7Tcy";